<template>
    <div class="pt-t mt-auto mb-4 border-b border-gray-200"></div>
    <footer class="text-[18px] leading-8">
        <div
            class="mx-auto gap-16 px-4 py-8 md:flex md:justify-center lg:container lg:gap-24"
        >
            <div class="mr-auto pb-8 md:pt-8">
                <img
                    src="/assets/art/logos/emtprep_logo_color.png"
                    class="w-[123px]"
                />
            </div>
            <div
                class="grid flex-grow grid-cols-1 gap-8 md:grid-cols-2 md:gap-8 lg:grid-cols-4"
            >
                <ul>
                    <li class="font-semibold">EMS Levels</li>
                    <li
                        class="text-[16px] text-gray-700"
                        v-for="item in menus.footer_ems_levels.items"
                    >
                        <NavLink
                            :href="item.url"
                            :text="item.name"
                            :type="item.type"
                        >
                            {{ item.name }}
                        </NavLink>
                    </li>
                </ul>
                <ul>
                    <li class="font-semibold">NREMT Exam Info</li>
                    <li
                        class="text-[16px] text-gray-700"
                        v-for="item in menus.footer_nremt_exam_info.items"
                    >
                        <NavLink
                            :href="item.url"
                            :text="item.name"
                            :type="item.type"
                        >
                            {{ item.name }}
                        </NavLink>
                    </li>
                </ul>
                <ul>
                    <li class="font-semibold">Legal</li>
                    <li
                        class="text-[16px] text-gray-700"
                        v-for="item in menus.footer_legal.items"
                    >
                        <NavLink
                            :href="item.url"
                            :text="item.name"
                            :type="item.type"
                        >
                            {{ item.name }}
                        </NavLink>
                    </li>
                </ul>
                <ul>
                    <li class="font-semibold">Company</li>
                    <li
                        class="text-[16px] text-gray-700"
                        v-for="item in menus.footer_company.items"
                    >
                        <NavLink
                            :href="item.url"
                            :text="item.name"
                            :type="item.type"
                        >
                            {{ item.name }}
                        </NavLink>
                    </li>
                    <li>
                        <div class="mt-2 flex gap-2">
                            <NavLink
                                href="https://twitter.com/emtprep"
                                target="_blank"
                            >
                                <svg
                                    width="36"
                                    height="36"
                                    viewBox="0 0 36 36"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="18"
                                        cy="18"
                                        r="18"
                                        fill="#121212"
                                    />
                                    <path
                                        d="M29.1621 11.655C28.3986 11.9926 27.589 12.2144 26.7601 12.313C27.6338 11.7904 28.2878 10.968 28.6001 9.99895C27.7801 10.4869 26.8811 10.8289 25.9441 11.0139C25.3147 10.3405 24.4804 9.89391 23.571 9.74353C22.6616 9.59316 21.728 9.74744 20.9153 10.1824C20.1026 10.6174 19.4564 11.3086 19.0772 12.1487C18.6979 12.9889 18.6068 13.9307 18.8181 14.828C17.1552 14.7446 15.5284 14.3125 14.0433 13.5596C12.5583 12.8068 11.2482 11.75 10.1981 10.458C9.82634 11.0964 9.63101 11.8222 9.63205 12.5609C9.63205 14.011 10.3701 15.292 11.4921 16.042C10.8281 16.021 10.1787 15.8417 9.59805 15.519V15.5709C9.59825 16.5367 9.93242 17.4726 10.5439 18.22C11.1554 18.9675 12.0065 19.4804 12.9531 19.672C12.3367 19.839 11.6904 19.8636 11.0631 19.7439C11.3299 20.5752 11.8501 21.3021 12.5506 21.8231C13.2512 22.344 14.0972 22.6327 14.9701 22.6489C14.1025 23.3303 13.1092 23.8339 12.0469 24.1311C10.9846 24.4283 9.87418 24.5132 8.77905 24.3809C10.6908 25.6104 12.9161 26.2631 15.1891 26.2609C22.8821 26.2609 27.0891 19.888 27.0891 14.361C27.0891 14.181 27.0841 13.999 27.0761 13.821C27.8949 13.2291 28.6017 12.496 29.1631 11.656L29.1621 11.655Z"
                                        fill="white"
                                    />
                                </svg>
                            </NavLink>
                            <NavLink
                                href="http://www.facebook.com/pages/EMT-Prep-LLC/112400242156027"
                                target="_blank"
                            >
                                <svg
                                    width="36"
                                    height="36"
                                    viewBox="0 0 36 36"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="18"
                                        cy="18"
                                        r="18"
                                        fill="#121212"
                                    />
                                    <path
                                        d="M20 19.5H22.5L23.5 15.5H20V13.5C20 12.47 20 11.5 22 11.5H23.5V8.14C23.174 8.097 21.943 8 20.643 8C17.928 8 16 9.657 16 12.7V15.5H13V19.5H16V28H20V19.5Z"
                                        fill="white"
                                    />
                                </svg>
                            </NavLink>
                            <NavLink
                                href="https://www.youtube.com/user/EMTprepLLC"
                                target="_blank"
                            >
                                <svg
                                    width="36"
                                    height="36"
                                    viewBox="0 0 36 36"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="18"
                                        cy="18"
                                        r="18"
                                        fill="#121212"
                                    />
                                    <path
                                        d="M25.606 12.995C25.53 12.697 25.314 12.472 25.067 12.403C24.63 12.28 22.5 12 18 12C13.5 12 11.372 12.28 10.931 12.403C10.687 12.471 10.471 12.696 10.394 12.995C10.285 13.419 10 15.196 10 18C10 20.804 10.285 22.58 10.394 23.006C10.47 23.303 10.686 23.528 10.932 23.596C11.372 23.72 13.5 24 18 24C22.5 24 24.629 23.72 25.069 23.597C25.313 23.529 25.529 23.304 25.606 23.005C25.715 22.581 26 20.8 26 18C26 15.2 25.715 13.42 25.606 12.995ZM27.543 12.498C28 14.28 28 18 28 18C28 18 28 21.72 27.543 23.502C27.289 24.487 26.546 25.262 25.605 25.524C23.896 26 18 26 18 26C18 26 12.107 26 10.395 25.524C9.45 25.258 8.708 24.484 8.457 23.502C8 21.72 8 18 8 18C8 18 8 14.28 8.457 12.498C8.711 11.513 9.454 10.738 10.395 10.476C12.107 10 18 10 18 10C18 10 23.896 10 25.605 10.476C26.55 10.742 27.292 11.516 27.543 12.498ZM16 21.5V14.5L22 18L16 21.5Z"
                                        fill="white"
                                    />
                                </svg>
                            </NavLink>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>
<script>
import NavLink from "@/Components/NavLink";

export default {
    name: "FrontendFooter",
    components: { NavLink },
    data() {
        return {
            menus: this.$page.props.frontend_menus,
        };
    },
};
</script>
